import React from 'react';
import { EmergencyMode } from 'core/models/drive';
import { DriveModeButton } from '../../atoms/DriveModeButton';
import { exhaustiveCheck } from 'utility/exhaustiveCheck';
import styled from '@emotion/styled';

const NormalButton = DriveModeButton;

const EmergencyButton = styled(DriveModeButton)({
    backgroundColor: '#d9534f', borderColor: '#d43f3a',
    hover: { backgroundColor: '#c9302c', borderColor: '#ac2925' }
});

function textForMode(mode: EmergencyMode) {
    switch (mode) {
        case EmergencyMode.Normal:
            return 'NORMAL';
        case EmergencyMode.Emergency:
        case EmergencyMode.EmergencyAll:
            return 'EMERGENCY';
        default:
            throw (exhaustiveCheck(mode));
    }
}

export type EmergencyModeButtonProps = {
    className?: string;
    mode: EmergencyMode;
    onClick?: () => void;
}

export const EmergencyModeButton = (props: EmergencyModeButtonProps) => {
    const text = textForMode(props.mode);

    return (
        text === 'NORMAL'
            ? <NormalButton {...props}>{text}</NormalButton>
            : <EmergencyButton {...props}>{text}</EmergencyButton>
    );
};
